import { WasteKind } from "generated-graphql/graphql";
import { FilterKey } from "hooks/useOmnisearchDatagrid";
import { DECLARED_WASTE_KIND_LABELS } from "routes/Customer/Waste/Manifests/extractionReview";

const WASTE_KINDS = Object.values(WasteKind);

/**
 * "Waste Kind" filter for the staff Manifest Review queue: manifests with a line whose
 * waste stream is one of the chosen kinds. Paired with the Data Quality Rule filter, the
 * rule's finding must be on such a line.
 */
export const WASTE_KIND_FILTER: FilterKey = {
  key: "wasteKind",
  header: "Waste Kind",
  filterKeyType: "enumAutocomplete",
  enumValues: WASTE_KINDS,
  enumPresentationFunction: (value) => {
    const kind = WASTE_KINDS.find((option) => option === value);
    return kind ? DECLARED_WASTE_KIND_LABELS[kind] : value;
  },
};
